import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';
import { fetchReferrals } from '@app/store/slices/referralsSlice';
import PageHeading from '@shared/ui/PageHeading';
import { ThemeButton, ThemeButtonIcon } from '@shared/ui/buttons';
import { SearchTableLocal } from '@shared/ui/forms/search';
import { useReferralsBalanceHistory } from '@utils/drawer-hooks';
import { theme } from '@utils/libs/theme';
import { useMobileOverlay } from '@utils/hooks/useMobileOverlay';
import { HelpBtn } from '@widgets/buttons';
import ReferralsCopyLink from '@widgets/referrals/ReferralsCopyLink';
import ReferralsStats from '@widgets/referrals/ReferralsStats';
import ReferralsTable from '@widgets/tables/ReferralsTable';
import TableMenuBtn from '@widgets/tables/main/TableMenuBtn';

export default function ReferralsPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const { openReferralsBalanceHistory } = useReferralsBalanceHistory();
  const mobileSearch = useMobileOverlay();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    dispatch(fetchReferrals());
  }, [dispatch]);

  const searchElement = (
    <SearchTableLocal
      value={search}
      onChange={setSearch}
      placeholder={t('search_placeholder_my_users')}
    />
  );

  return (
    <section className="table-page main-section">
      {isMobile && mobileSearch.isOpen && (
        <div className="search-mobile-container">
          <div className="block-pd-x search-mobile">
            <ThemeButtonIcon icon="arrow-left" onClick={mobileSearch.close} />
            {searchElement}
          </div>
        </div>
      )}
      {(!isMobile || !mobileSearch.isOpen) && (
        <PageHeading title={t('Referrals')}>
          <HelpBtn page="referrals" />
          {isMobile ? (
            <>
              <ThemeButtonIcon icon="search" onClick={mobileSearch.open} />
              <TableMenuBtn menu="referrals" />
            </>
          ) : (
            <ThemeButton
              appearance="secondary"
              startIcon="history"
              onClick={openReferralsBalanceHistory}
            >
              {t('balance_history')}
            </ThemeButton>
          )}
        </PageHeading>
      )}
      <ReferralsStats />
      <div className="block-pd-x table-page__box">
        {!isMobile && (
          <div className="table-filters">
            <div className="table-filters-row">{searchElement}</div>
            <ReferralsCopyLink />
          </div>
        )}
        <div className="table-page__table">
          <ReferralsTable search={search} />
        </div>
      </div>
    </section>
  );
}
